import React,{Component} from 'react';
import { connect } from 'react-redux';
// restClient
import {eapiClient,aemHostClient,taxonomyHostClient} from '../../../../restClient';
// children
import PersistLink from '../../../common/PersistLink';
import SingleLineSelect from '../../../common/SingleLineSelect';
import SimpleDropdown from '../../../common/SimpleDropdown';
//action Creator
import { setPersons } from '../../actions/actionCreator';
//style
import {
  loadIfStateAvailableInSessionStorage,
  savePageStateInSessionStorage,
  Translations,
  convertStringToArray
} from '../../../../utils';

class SpainDeclarationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noOftaxDeclarationSignatories:1,
      disabletaxDeclarations: [],
      methodFlag:false,
      countrySpainForm:{
        taxDeclarationSignatories:[]
      },
      id:'',
      lid:'',
      countryOfTaxResidence:{},
      countryTaxResidence:[]
    }
    this.disableList =[];
  }

  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }

  loadPageState =()=>{
    var {caseId, productId} = this.props.match.params;
    eapiClient("/countryForms/case/" + caseId + "/product/" + productId)
    .then(({data}) => {
      this.setState({entityName:data.responseData.entityName})
      if(data.responseData.countrySpainForm !== undefined){
        this.setState({
          countryOfTaxResidence:data.responseData.countrySpainForm.countryOfTaxResidence,
          methodFlag:true,
          countrySpainForm:{...this.state.taxDeclarationSignatories,
            taxDeclarationSignatories:data.responseData.countrySpainForm.taxDeclarationSignatories
          }
        });

        const _taxDeclarationSignatoriesGet = data.responseData.countrySpainForm.taxDeclarationSignatories;
        if(_taxDeclarationSignatoriesGet && _taxDeclarationSignatoriesGet.length > 0 && this.state.noOftaxDeclarationSignatories !== _taxDeclarationSignatoriesGet.length) {
          this.setState({noOftaxDeclarationSignatories: _taxDeclarationSignatoriesGet.length});
        }
      }else  {
        this.setState({id:data.responseData.id, lid:data.responseData.lid,
          dataReady: true
        });
      }

    });

  }
  componentWillMount() {
    var {caseId} = this.props.match.params;
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });

    let apiURL ="/aemData/formData/json_spain-declaration-of-tax-residence-form";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_add-", "json_edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      this.setState({formJson:data});
    });
    taxonomyHostClient("/taxonomies/party/countries")
    .then(({data}) => {
      this.setState({ countryTaxResidence : data.responseData.countryTaxonomy.classificationNodes});
    });

    eapiClient("/persons/case/" + caseId)
    .then(({data}) => {
      this.props.setPersons(data.responseData);
    });
  }

  componentDidMount(){
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key'+ getCurrentDropDown);

    if(getCurrentDropDown !== null){
      var getCurrentDropDownName =  getCurrentDropDown.substring(0,getCurrentDropDown.length -1);
    }
    if(getCurrentDropDownName ==='taxDeclarationSignatories'){
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length -1);
    }

    if(getCurrentDropDownName === 'taxDeclarationSignatories'){
      if(this.state.countrySpainForm.taxDeclarationSignatories.length ===0 && getCurrentDropDownValue !== null){
        var _taxDeclarationSignatories = [...this.state.countrySpainForm.taxDeclarationSignatories];
        _taxDeclarationSignatories[0] = getCurrentDropDownValue;
        this.setState({
          countrySpainForm:{
            ...this.state.countrySpainForm,
            taxDeclarationSignatories: _taxDeclarationSignatories
          }
        });
      }
      this.state.countrySpainForm.taxDeclarationSignatories.forEach((currentValue, index, arr) =>{
        if(currentValue!==getCurrentDropDownValue && index===getCurrentDropDownIndex-1 && getCurrentDropDownValue !== null){
          var _taxDeclarationSignatories = [...this.state.countrySpainForm.taxDeclarationSignatories];
          _taxDeclarationSignatories[index] = getCurrentDropDownValue;
          this.setState({
            countrySpainForm:{
              ...this.state.countrySpainForm,
              taxDeclarationSignatories: _taxDeclarationSignatories
            }
          });
        }else if(getCurrentDropDownValue !== null && index!==getCurrentDropDownIndex-1 && getCurrentDropDownName === 'taxDeclarationSignatories') {
          var _taxDeclarationSignatories = [...this.state.countrySpainForm.taxDeclarationSignatories];
          _taxDeclarationSignatories[getCurrentDropDownIndex-1] = getCurrentDropDownValue;
          this.setState({
            countrySpainForm:{
              ...this.state.countrySpainForm,
              taxDeclarationSignatories: _taxDeclarationSignatories
            }
          });
        }
      })
    }
    window.sessionStorage.removeItem("getCurrentDropDown");
    window.sessionStorage.removeItem('key'+ getCurrentDropDown);
  }

  saveStateToSessionOnEdit = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }

  onFormSubmit = (event, apiURL) => {

  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  handleDeclarationSignatoriesChange = (index, accountSignatory) => {
    var _taxDeclarationSignatories = [...this.state.countrySpainForm.taxDeclarationSignatories];
    _taxDeclarationSignatories[index-1] = accountSignatory.id;
    this.setState({
      countrySpainForm:{...this.state.countrySpainForm,taxDeclarationSignatories: _taxDeclarationSignatories
      }});
    }
    handleDeclarationSignatoryEditClick = (declarationSignatory) => {
      if(declarationSignatory) {
        this.saveStateToSessionOnEdit();
        this.props.history.push("/case-body/create-new-declaration-signatory/" + declarationSignatory.id);
      }
    }
    ontaxDeclarationSignatoriesAddition = () => {
      this.setState(prevState => {
        return {noOftaxDeclarationSignatories: prevState.noOftaxDeclarationSignatories+1}
      });
    }

    onTaxDeclarationDeletion = (index) => {
      let _taxDeclarationSignatories= [...this.state.countrySpainForm.taxDeclarationSignatories];
      _taxDeclarationSignatories.splice(index, 1);
      this.setState(prevState => {
        return {
          noOftaxDeclarationSignatories: prevState.noOftaxDeclarationSignatories-1,
          countrySpainForm:{...prevState.countrySpainForm, taxDeclarationSignatories: _taxDeclarationSignatories}
        }
      });
    }

    setCountryTax = (event)=>{

      let _countryOfTaxResidence = {
        name: event.nativeEvent.target[event.nativeEvent.target.selectedIndex].text,
        value: event.target.value
      }
      this.setState({countryOfTaxResidence: _countryOfTaxResidence});
      }

      saveForm =() =>{
        var payLoad={};
        var countrySpainForm ={};
        var {caseId, productId} = this.props.match.params;
        countrySpainForm.countryOfTaxResidence = this.state.countryOfTaxResidence;
        countrySpainForm.taxDeclarationSignatories = this.state.countrySpainForm.taxDeclarationSignatories;
        payLoad.caseId = caseId;
        payLoad.productId=productId;
        payLoad.countrySpainForm= countrySpainForm;
        payLoad.id = this.state.id;
        payLoad.lid = this.state.lid;
        payLoad.countryFormName="Spain declaration form";
        let apiURL;

        apiURL ="/countryForms/case/" + caseId + "/product/" + productId
        eapiClient(apiURL,{
          method:"PUT" ,
          data: JSON.stringify(payLoad)

        })
        .then(({data}) => {
        });
        this.props.history.goBack();
      }

      render() {
        let addAccountSignatoryButtonJsx = "";
        var {caseId} = this.props.match.params;

        let buttonJsx =(<h3>Loading.....</h3>);
        if(this.state.formJson){
          buttonJsx =(<div>
            <button onClick={this.saveForm} aria-label={this.state.formJson.guideContainer.rootPanel.items.guidebutton_saveAndReturn.text} className="gdocs-btn-submit"> {this.translations(this.state.formJson.guideContainer.rootPanel.items.guidebutton_saveAndReturn.text)}</button>
            </div>);
            addAccountSignatoryButtonJsx = (
              <button className="gdocs-btn-default" onClick={this.ontaxDeclarationSignatoriesAddition}><i className="icon icon-add"></i> {`${this.translations(this.state.formJson.guideContainer.rootPanel.items['guidetextbox_slot1'].addText)} ${this.state.noOftaxDeclarationSignatories+1}`}</button>
            );
          }
          let taxDeclarationSignatoriesJsx =[];
          const pageTitle = this.state.formJson ? this.state.formJson.guideContainer.rootPanel.items.static_text_mainTitle : {};
          let simpledropJsx =(<SimpleDropdown name="countryTaxResidence"
          value={this.state.countryOfTaxResidence.value}
          defaultValue ={this.state.formJson !== undefined ? this.translations(this.state.formJson.guideContainer.rootPanel.items.static_text_pleaseSelect.text) : ''}
          _onChange={this.setCountryTax}
          options={this.state.countryTaxResidence}
          optionTextSelector={"name"}
          type="country" />)

          for(var i = 1; i<=this.state.noOftaxDeclarationSignatories; i++) {
            if(this.state.formJson!== undefined){
              taxDeclarationSignatoriesJsx.push(<div className="account-signatory-wrapper">
              <div className="gdocs-clear-float"></div>
              <div className="account-signatory-position">{`${this.translations(this.state.formJson.guideContainer.rootPanel.items['guidedropdownlist_Spd6-i'].title)} ${i}`}</div>
              <div className="account-signatory-position">
              {(i > 1) ? <span className="delete-btn" role="button" onClick={this.onTaxDeclarationDeletion.bind(this, i-1)}><i className="icon icon-bin"></i></span> : ''}
              {
                this.props.persons.length > 0 ?
                (<SingleLineSelect defaultValue={this.translations(this.state.formJson.guideContainer.rootPanel.items.static_text_pleaseSelect.text)}
                requiredFields={["firstName", "lastName", "jobTitle"]}
                optionsData={this.props.persons || []}
                disabledOptions={this.state.countrySpainForm.taxDeclarationSignatories}
                _value={this.state.countrySpainForm.taxDeclarationSignatories[i-1] !== undefined ? this.state.countrySpainForm.taxDeclarationSignatories[i-1] : ''}
                onEdit={this.handleDeclarationSignatoryEditClick} _onChange={this.handleDeclarationSignatoriesChange.bind(this, i)} />):''
              }
              <span className="icon icon-add addicon"></span>
              <PersistLink className="mrg-left"
              history={this.props.history}
              state={this.state}
              to={'/case-body/country-forms/create-signatory/' + caseId + '/'}
              data={`taxDeclarationSignatories${i}`}>
              {this.translations(this.state.formJson.guideContainer.rootPanel.items['guidedropdownlist_Spd6-i'].createText)}
              </PersistLink>
              </div>
              <div className="gdocs-clear-float"></div>
              </div>)
            };
          }

          return (
            (this.state.formJson !== undefined ?
              <div className="form-container">
              <div className="form-title">
              <h1 className="form-heading">{this.translations(pageTitle.name)}</h1>
              <div className="gdocs-clear-float"></div>
              <p className="pannel-sub-heading">{this.state.entityName}</p>
              <p className="form-required-desc optional-text">{this.translations(pageTitle.text)}</p>
              </div>
              <div className="gdocs-clear-float"></div>
              <div className="span-declaration-form">
              <div className="gdocs-tax-country-residence">
              <label className="gdocs-tax-country-residence-lbl">{this.translations(this.state.formJson.guideContainer.rootPanel.items['guidedropdownlist_Spd5-i'].title)}</label>
              {simpledropJsx}
              </div>
              <div className="gdocs-clear-float"></div>
              {taxDeclarationSignatoriesJsx}
              <div>{addAccountSignatoryButtonJsx}</div>
              </div>
              <div key="buttons-wrapper" className="form-buttons-section country-form-buttons-section">
              <div className="form-buttons-wrapper">
              {buttonJsx}
              </div>
              </div>
              </div>
              :''));
            }
          }
          const mapStateToProps = state => {
            return {
              persons: state.persons,
              lang:state.lang
            }
          }
          const mapDispatchToProps = dispatch => {
            return {
              setPersons: persons => {
                dispatch(setPersons(persons));
              }
            }
          }
          export default connect(mapStateToProps, mapDispatchToProps)(SpainDeclarationForm);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/SpainDeclarationForm.js